<style lang="less" scoped>
.question{width: 35%;box-sizing: border-box;}
header{width: 95%;height: 10%;margin-left: 3%;margin-top: 3%;}
.article{width: 95%;margin-left: 3%;margin-top: 2%;box-sizing: border-box;}
.wt{width:100%;height: 20%;margin-bottom:3%;padding: 4% 0; border: 1px solid gray;border-radius: 5px; cursor: pointer;}
// .wt span{padding:20%}
.da{width:100%;height: 20%;margin-bottom:3%;padding: 4% 0; border: 1px solid gray;border-radius: 5px; cursor: pointer;}
.as{margin-top: 4%;}
.qs{margin-top: -2%;}
</style>

<template>
<div class="question" v-show="isShowAnswer">
    <header>
        <i class="el-icon-question" style="position: relative;left: -38%;top: 25%;font-size: 30px;color:rgb(3 195 246);"></i>
        <span style="position: relative;left: -38%;top: -5px;font-size: 19px;color: #0152b5;">常见问题</span>
        <span style="position: relative;left: 38%;top: 20%;font-size: 19px;">
            <i class="el-icon-close" @click="onDisnear"></i>
        </span>
    </header>
    <div class="article">
      <div v-for="(item,index) in qustion" :key="index">
        <div class="wt" v-show="isshowquestion[index].qs" @click="onChange(index)">
            <span style="position: absolute;left: 5%;color: rgb(3 195 246);margin-top: -1.5%;">问题{{index+1}}</span>
            <span style="position: absolute;left: 13%;margin-top: -1.5%;">{{item.qs}}</span>
            <i style="position: absolute;right: 5%;font-size: 18px;margin-top: -1.5%;" class="el-icon-arrow-down"></i>
        </div>
        <div class="da" v-show="!isshowquestion[index].qs" @click="onChange(index)">
          <div class="qs">
            <span style="position: absolute;left: 5%;color: rgb(3 195 246);">问题{{index+1}}</span>
            <span style="position: absolute;left: 13%;">{{item.qs}}</span>
            <i style="position: absolute;right: 5%;font-size: 18px;" class="el-icon-arrow-up"></i>
          </div>
          <div class="as">
            <span style="position: absolute;left: 7%;color: #6cd395">答：</span>
            <span style="position: absolute;left: 13%;display: inline;background-color: rgb(235 235 235);">
              {{item.as}}
            </span>
          </div>
        </div>
        </div>
    </div>
     <el-button>查看更多</el-button>
</div>
</template>

<script>
export default {
  data()
  {
    return {
      isShowAnswer: true,
      isshowquestion: [
        {qs: 'true'},
        {qs: 'true'},
        {qs: 'true'},
        {qs: 'true'},
        {qs: 'true'},
        {qs: 'true'},
        {qs: 'true'},
        {qs: 'true'}
      ],
      // isshowquestion: ['true','true','true','true','true','true','true','true'],
      // isshowanswear: ['false','false','false','false','false','false','false','false'],
      qustion: [
        {
          qs: '单位、企业、个人还是其他形式的组织？',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '矿种介绍？',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '怎么参与投资？',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '海外投资相关的法律？',
          as1: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '投资的方式有哪些？',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '海外投资相关的法律？',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '怎么参与投资？',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        },
        {
          qs: '矿种介绍?',
          as: '单位组织，回答上面问题，具体内容包括列举所有用户再使用本咨询功能'
        }
      ]
    }
  },
  methods: {
    onChange(index)
    {
      this.isshowquestion[index].qs = !this.isshowquestion[index].qs
      // this.isShowAnswer = !this.isShowAnswer
    },
    onDisnear()
    {
      // this.isShowAnswer = false
      this.$parent.comProblem()
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/CJQuestion.vue